export const getExportItemIds = (config) =>
  config.sections.flatMap((section) => section.items.map((item) => item.id));

export const getExportItemsById = (config) => {
  const map = new Map();
  config.sections.forEach((section) => {
    section.items.forEach((item) => {
      map.set(item.id, item);
    });
  });
  return map;
};

export const buildFilterSummary = (config, filterValues = {}) =>
  config.filterFields.map(({ key, label }) => ({
    label,
    value: filterValues[key] ?? 'All',
  }));
